import { store } from "../../../../store";
import { groupSingleShift } from "../../../Pagat/PaySub/employeeCalc/calculcate";
import {
  buildReportResult,
  emptyReportResult,
  employeeFullName,
  intervalBounds,
  round2,
} from "../reportResult";

/**
 * Hours + estimated cost by employee (rate × hours), filterable by dept/team.
 */
export const hoursCostByDept = (
  _prev,
  filter,
  columns,
  manualColumns,
  employees,
) => {
  if (!filter) return emptyReportResult(columns, manualColumns);

  const data = store?.getState()?.customReducer?.reportClockings || [];
  const { startTs, endTs } = intervalBounds(filter);
  const empById = new Map((employees || []).map((e) => [e.employeeId, e]));
  const agg = new Map();

  for (const d of data) {
    if (!d?.clockInDate || !d?.clockOutDate) continue;
    if (d.clockInDate < startTs || d.clockInDate > endTs) continue;
    if (filter?.employeeId && d.employeeId !== filter.employeeId) continue;

    const emp = d.employeeDetails || empById.get(d.employeeId) || {};
    const id = d.employeeId;
    if (!agg.has(id)) {
      const rate =
        Number(d?.totalities?.employeeRate) ||
        Number(emp?.employeeSalaryPerHour) ||
        0;
      agg.set(id, {
        employee: employeeFullName(emp),
        employeeDepartmentName: emp.employeeDepartmentName || "",
        employeeTeam: emp.employeeTeam || "",
        before19: 0,
        between19and22: 0,
        after22: 0,
        totalHours: 0,
        employeeRate: rate,
        estimatedCost: 0,
      });
    }
    const row = agg.get(id);
    const {
      NORMAL_HOURS = {},
      LATE_HOURS = {},
      EXTRA_HOURS = {},
    } = groupSingleShift(d) || {};
    const n = Number(NORMAL_HOURS?.amount) || 0;
    const l = Number(LATE_HOURS?.amount) || 0;
    const e = Number(EXTRA_HOURS?.amount) || 0;
    const pay = Number(d?.totalities?.totalPay);
    row.before19 += n;
    row.between19and22 += l;
    row.after22 += e;
    row.totalHours += n + l + e;
    if (Number.isFinite(pay) && pay > 0) {
      row.estimatedCost += pay;
    } else {
      row.estimatedCost += (n + l + e) * row.employeeRate;
    }
  }

  const preFilter = [...agg.values()]
    .map((r) => ({
      ...r,
      before19: round2(r.before19),
      between19and22: round2(r.between19and22),
      after22: round2(r.after22),
      totalHours: round2(r.totalHours),
      employeeRate: round2(r.employeeRate),
      estimatedCost: round2(r.estimatedCost),
    }))
    .sort((a, b) =>
      String(a.employeeDepartmentName).localeCompare(
        String(b.employeeDepartmentName),
        "sq",
      ) ||
      String(a.employee).localeCompare(String(b.employee), "sq"),
    );

  return buildReportResult(preFilter, columns, manualColumns);
};
